import React, { FC } from 'react'
import SALink from 'components/SALink'
import StudioIcon from 'svg/studio-action-icon.svg'
import styles from './StudioLink.module.scss'
import { useSelector } from 'react-redux'
import { getUserTypeId, isAuthenticated, isSessionSet } from 'selectors/user/session'

const StudioLink: FC = () => {
  const isSessionReady = useSelector(isSessionSet)
  const authenticated = useSelector(isAuthenticated)
  const userTypeId = useSelector(getUserTypeId)

  // Must have session | authenticated | artist
  if (!isSessionReady || !authenticated || userTypeId !== 2) {
    return null
  }

  return (
    <div className={styles.mobileHiddenIconContainer}>
      <SALink
        data-gtm-event='top-nav'
        data-type='studio'
        href='/studio'
        title='View Studio'
        rel='nofollow'
      >
        <StudioIcon className={styles.studioIcon} data-type='studio-icon' />
      </SALink>
    </div>
  )
}

export default StudioLink
